import { useThunkActions } from '../useThunkActions'
import { SnackbarMessage, SnackbarOptions } from 'types/GlobalSnackbar'

import * as actions from './actions'

export const toggleSnackbarClosed = () => actions.close()

export const toggleSnackbarOpen = (
  message: SnackbarMessage,
  options?: SnackbarOptions
) => actions.open({ message, options })

export const useSnackbarActions = () => {
  return {
    toggleSnackbarClosed: useThunkActions(toggleSnackbarClosed),
    toggleSnackbarOpen: useThunkActions(toggleSnackbarOpen)
  }
}
